export default __webpack_public_path__ + "static/media/red_anim.f163626d.gif";